<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     设备名
  +---------------------------------------------------------------------------------------
-->
<template>
  <div>
    <el-link v-if="link" :underline="false" @click.stop="toDetail">{{ title }}</el-link>
    <span v-else>{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: "FEquipName",

  props: {
    equip: {
      type: Object,
      default() {
        return {}
      },
    },

    link: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      equipDetailShow: false,
      equipid: 0
    }
  },

  computed: {
    title() {
      return this.equip.equip_name || this.equip.name || this.equip.go
    }
  },

  methods: {
    toDetail() {
      this.$detail({type:'equip',id:this.equip.equipid})
    },
  }
}
</script>
